import { useAuthStore } from '../stores/authStore';

const PUBLISHER_URL =
  (import.meta.env.VITE_PROMOTION_PUBLISHER_URL as string | undefined) ??
  'https://promotion.summio.org';

const PUBLISHER_ORIGIN = new URL(PUBLISHER_URL).origin;

export function installPublisherAuthFetch(): void {
  const win = window as Window & { __summioPublisherAuthFetchInstalled?: boolean };
  if (win.__summioPublisherAuthFetchInstalled) return;
  win.__summioPublisherAuthFetchInstalled = true;

  const nativeFetch = window.fetch.bind(window);

  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const url = requestUrl(input);
    if (!url || url.origin !== PUBLISHER_ORIGIN) {
      return nativeFetch(input, init);
    }

    const token = useAuthStore.getState().token;
    const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
    if (token && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    if (input instanceof Request) {
      return nativeFetch(new Request(input, { ...init, headers }));
    }

    return nativeFetch(input, { ...init, headers });
  };
}

function requestUrl(input: RequestInfo | URL): URL | null {
  try {
    if (typeof input === 'string') return new URL(input, window.location.href);
    if (input instanceof URL) return input;
    if (input instanceof Request) return new URL(input.url);
    return null;
  } catch {
    return null;
  }
}
